enum FEATURE_TYPE {
    AUTO_STACKING = 'autostacking',
    CLOSING_TOOL = 'closingTool',
    DRIVERS_ETA = 'driversEta',
    ETA_COMMENT = 'etaComment',
    EXTERNAL_API_FORWARDER = 'externalApiForwarder',
    FLEETS = 'fleets',
    FULL_ETA = 'fullEta',
    JSON_TRANSFORM = 'jsonTransform',
    PREPARATION_TIME = 'preparationTime',
    PRICE_MATRIX = 'priceMatrix',
    QUOTE_DENYING = 'quoteDenying',
    SMART_FLEET_CHOICE = 'smartFleetChoice',
    WEBHOOK = 'webhook',
    E2E_FLOW = 'e2eFlow',
}

export default FEATURE_TYPE;
